<div class="panel-root">
  <mat-drawer-container class="app-container" [hasBackdrop]="drawerMode() === 'over'"
    (backdropClick)="ss.showSidebar.set(false)">
    <mat-drawer class="sidebar" [class.mobile-sidebar]="isMobileLayout()" [opened]="ss.showSidebar() && cc.loggedIn()"
      #drawer [mode]="drawerMode()">
      <div class="brand-logo">
        <app-svg [name]="brandLogo" class="logo cursor-pointer"
          [color]="isMobileLayout() ? ss.theme().color12 : ss.theme().color35" style="height: 20px;"
          (click)="navigateToHome()" (mousedown)="startPressToOpenDebug()" (mouseup)="endPressToOpenDebug()"
          (mouseleave)="endPressToOpenDebug()" (touchstart)="startPressToOpenDebug()"
          (touchend)="endPressToOpenDebug()"></app-svg>
        <app-svg name="sidebarCollapse" class="sidebar-collapse-icon icon-mirror-rtl" (click)="ss.toggleSidebar()"
          role="button" [color]="ss.theme().color8" height="22" width="22"></app-svg>
      </div>
      <div class="sidebar-nav hide-scrollbar flex flex-col gap-4">
        <div class="sidebar-nav-block">
          <h6 class="block-heading">{{ ss.t('hamburgerTray_main') }}</h6>
          <a class="nav-item" routerLink="/today" routerLinkActive="active" #rlaToday="routerLinkActive"
            (click)="clickNav()">
            <app-svg name="radioButton" class="nav-icon" height="22" width="22"
              [color]="cc.isNarrowScreen() && !rlaToday.isActive ?  ss.theme().color35 : rlaToday.isActive ? ss.theme().color12 : ss.theme().color8"></app-svg>
            <span>{{ ss.t('common_home') }}</span>
          </a>
          <a class="nav-item flex items-center justify-between !pe-[6px]" routerLink="/features"
            routerLinkActive="active" #rlaFeatures="routerLinkActive" (click)="clickNav()">
            <div class="flex items-center gap-2">
              <app-svg name="feature" height="22" width="22"
                [color]="cc.isNarrowScreen() && !rlaFeatures.isActive ? ss.theme().color35 : rlaFeatures.isActive ? ss.theme().color12 : ss.theme().color8"></app-svg>
              <span>{{ ss.t('hamburgerTray_features') }}</span>
            </div>
            <app-svg name="featureFabOverLay" class="nav-icon !ms-[16px] !me-0"
              [color]="cc.isNarrowScreen() && !rlaFeatures.isActive ? ss.theme().color35 : rlaFeatures.isActive ? ss.theme().color12 : ss.theme().color8"
              style="height: 14px; width: 14px;"></app-svg>
          </a>
          @if (ss.isFeatureFlagEnabled('voice_commands')) {
          <a class="nav-item" routerLink="/meo-history" routerLinkActive="active" #rlaMeo="routerLinkActive"
            (click)="clickNav()">
            <app-svg name="meoSparkle" class="nav-icon" height="22" width="22"
              [color]="cc.isNarrowScreen() && !rlaMeo.isActive ? ss.theme().color35 : rlaMeo.isActive ? ss.theme().color12 : ss.theme().color8"></app-svg>
            <span>{{ ss.t('meo_title') }}</span>
            <span class="meo-badge">{{ ss.t('meo_badge') }}</span>
          </a>
          }
          <a class="nav-item" routerLink="/attachment" routerLinkActive="active" #rlaAttachment="routerLinkActive"
            (click)="clickNav()">
            <app-svg name="attachment" class="nav-icon" style="height: 18px; width: 22px;"
              [color]="cc.isNarrowScreen() && !rlaAttachment.isActive ? ss.theme().color35 : rlaAttachment.isActive ? ss.theme().color12 : ss.theme().color8"></app-svg>
            <span>{{ ss.t('common_attachment') }}</span>
          </a>
          <a class="nav-item cursor-pointer" routerLinkActive="active" #rlaInsight="routerLinkActive"
            (click)="openInsight()">
            <app-svg name="insight" class="nav-icon icon-mirror-rtl" height="22" width="22"
              [color]="cc.isNarrowScreen() && !rlaInsight.isActive ? ss.theme().color35 : rlaInsight.isActive ? ss.theme().color12 : ss.theme().color8"></app-svg>
            <span>{{ ss.t('common_dropdownInsight') }}</span>
          </a>
          <a class="nav-item" routerLink="/collaborators" routerLinkActive="active" #rlaCollaborators="routerLinkActive"
            (click)="clickNav()">
            <app-svg name="users" class="nav-icon" height="22" width="22"
              [color]="cc.isNarrowScreen() && !rlaCollaborators.isActive ? ss.theme().color35 : rlaCollaborators.isActive ? ss.theme().color12 : ss.theme().color8"></app-svg>
            <span>{{ ss.t('collaborators_title') }}</span>
          </a>
          <a class="nav-item" routerLink="/trash" routerLinkActive="active" #rlaTrash="routerLinkActive"
            (click)="clickNav()">
            <app-svg name="trash" class="nav-icon" height="22" width="22"
              [color]="cc.isNarrowScreen() && !rlaTrash.isActive ? ss.theme().color35 : rlaTrash.isActive ? ss.theme().color12 : ss.theme().color8"></app-svg>
            <span>{{ ss.t('hamburgerTray_featuresTrash') }}</span>
          </a>
        </div>
        <div class="sidebar-nav-block">
          <h6 class="block-heading">{{ ss.t('common_filterAccount') }}</h6>
          <a class="nav-item" (click)="openPublicProfile()" role="button"
            [ngClass]="{'active': isPublicProfileActive()}">
            @if (cc.loggedIn()) {
            <app-me-user-avatar [uid]="cc.user.uid" [radius]="9" class="nav-icon badgeClass"></app-me-user-avatar>
            }
            <span>{{ ss.t('common_publicProfile') }}</span>
          </a>
          <a class="nav-item" routerLink="/settings" routerLinkActive="active" #rlaSettings="routerLinkActive"
            (click)="clickNav()">
            <app-svg name="setting" class="nav-icon" height="22" width="22"
              [color]="cc.isNarrowScreen() && !rlaSettings.isActive ? ss.theme().color35 : rlaSettings.isActive ? ss.theme().color12 : ss.theme().color8"></app-svg>
            <span>{{ ss.t('settings_title') }}</span>
          </a>
        </div>
        <div class="sidebar-nav-block">
          <h6 class="block-heading">{{ ss.t('hamburgerTray_help') }}</h6>
          <a class="nav-item" routerLink="/chat" routerLinkActive="active" #rlaChat="routerLinkActive"
            (click)="clickNav()">
            <app-svg name="chat" class="nav-icon icon-mirror-rtl" height="22" width="22"
              [color]="cc.isNarrowScreen() && !rlaChat.isActive ? ss.theme().color35 : rlaChat.isActive ? ss.theme().color12 : ss.theme().color8"></app-svg>
            <span>{{ ss.t('common_support') }}</span>
          </a>
          <a class="nav-item" routerLink="/feature-guide" routerLinkActive="active" #rlaFeatureGuide="routerLinkActive"
            (click)="clickNav()">
            <app-svg name="info" class="nav-icon" height="22" width="22"
              [color]="cc.isNarrowScreen() && !rlaFeatureGuide.isActive ? ss.theme().color35 : rlaFeatureGuide.isActive ? ss.theme().color12 : ss.theme().color8"></app-svg>
            <span>{{ ss.t('common_featureGuide') }}</span>
          </a>
          <a class="nav-item" routerLink="/feedback" routerLinkActive="active" #rlaFeedback="routerLinkActive"
            (click)="clickNav()" role="button">
            <app-svg name="bulb" class="nav-icon" height="22" width="22" [color]="cc.isNarrowScreen() && !rlaFeedback.isActive ? ss.theme().color35 : rlaFeedback.isActive ? ss.theme().color12 : ss.theme().color8"></app-svg>
            <span>{{ ss.t('common_feedback') }}</span>
          </a>
        </div>
      </div>
    </mat-drawer>

    <mat-drawer-content [class.side-nav-opened]="ss.showSidebar() && cc.loggedIn()"
      [class.mobile-layout]="isMobileLayout()">
      <app-svg name="hamburger" class="hamburger-open-icon" [class.hidden]="ss.showSidebar()"
        (click)="ss.toggleSidebar()" role="button" [color]="ss.theme().color8" *ngIf="cc.loggedIn()"></app-svg>

      <div class="panel-container">
        <app-habit-timer-tracker></app-habit-timer-tracker>
        <div class="panel-content">
          <router-outlet />
        </div>
      </div>
    </mat-drawer-content>
  </mat-drawer-container>

  <!-- Meo AI Side Panel Overlay -->
  @if (meoStore.isPanelOpen()) {
  <div class="meo-overlay-backdrop" (click)="meoStore.closePanel()"></div>
  <div class="meo-panel-container">
    <app-meo-page></app-meo-page>
  </div>
  }
</div>